import { ValidationObserver, ValidationProvider } from "vee-validate";
import {MaintenanceTemplate} from "@/models/maintenance/MaintenanceTemplate";

export default {
  name: "MaintenanceTemplatesDlg",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      template: null,
      loading: false,
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    }
  },
  methods: {
    open() {
      this.dialog = true;
      this.template = new MaintenanceTemplate(this.facilityId);
    },
    close() {
      this.dialog = false;
    },
    async submit() {
      try {
        this.loading = true;
        this.template.template = `{"title": "${this.template.name}"}`
        const template = Object.assign({}, this.template);
        await this.$store.dispatch("addMaintenanceTemplate", template)
          .then(data => {
            this.$router.push(`/maintenanceTemplates/${data.id}`);
          })

        this.$toast.open({
          type: "success",
          message: this.$t("MaintenanceTemplates.SuccessCreated")
        });

        this.close();
      } catch (err) {
        this.$toast.open({
          type: "error",
          message: err.message
        });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    'template.name'(val, oldVal) {
      this.$refs.observer?.validate();
    }
  }
}